<script lang="ts">
  // Stylized brand mark — building above three wavy ground lines.
  // Used on Landing and in TripPage's header (signed-out variant) as
  // the "home" link's icon.
  let { size = 22 }: { size?: number } = $props();
</script>

<svg
  viewBox="0 0 64 64"
  width={size}
  height={size}
  fill="currentColor"
  aria-hidden="true"
  style="display: block;"
>
  <!-- Content wrapped in a transform that nudges everything down 6
       viewBox units. The filled building (rects) carries most of the
       visual weight and originally sat with its mass center near
       y≈23 — well above the 32-unit box center. Inline next to text
       (TripPage header), that mass-center offset reads as the icon
       "floating above" its line-mates. Shifting content down centers
       the perceived weight around y≈29 (much closer to 32). The
       bottom wave shifts from y=57 → y=63, still inside the 64-unit
       viewBox so nothing clips. -->
  <g transform="translate(0 6)">
    <path d="M 2 44 Q 12 42.5 22 44 T 42 44 T 62 44" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M 24 44 A 8 8 0 0 1 40 44 Z"/>
    <path d="M 4 51 Q 12 48 20 51 T 36 51 T 52 51 T 60 51" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.7"/>
    <path d="M 4 57 Q 12 54 20 57 T 36 57 T 52 57 T 60 57" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.45"/>
    <rect x="5" y="8" width="54" height="5"/>
    <rect x="14" y="13" width="5" height="9"/>
    <rect x="45" y="13" width="5" height="9"/>
    <rect x="8" y="22" width="48" height="5"/>
    <rect x="14" y="27" width="5" height="23"/>
    <rect x="45" y="27" width="5" height="23"/>
  </g>
</svg>
